// Konfiguracja tabeli „Koszyki” na karcie klienta (Panel Handlowca)

import React from 'react';
import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';
import { EditIcon } from 'assets/icons';

/**
 * Parametry (opcje nad tabelą) – brak
 */
export const getTraderClientCardCartsTableParameters = (): IWiseTableParameter[] => {
  return [];
};

/**
 * Kolumny tabeli: nazwa koszyka, id koszyka, wartość koszyka
 */
export const getTraderClientCardCartsTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'text',
      label: t('Nazwa koszyka'),
      field_symbol: 'name',
      align: 'left',
      tooltip: null,
      size: 200
    },
    {
      type: 'text',
      label: t('Id koszyka'),
      field_symbol: 'id',
      align: 'center',
      tooltip: null,
      size: 120
    },
    {
      type: 'text',
      label: t('Wartość koszyka netto'),
      field_symbol: 'value_net',
      align: 'center',
      tooltip: null,
      size: 140
    },
    {
      type: 'text',
      label: t('Wartość koszyka brutto'),
      field_symbol: 'value_gross',
      align: 'center',
      tooltip: null,
      size: 140
    }
  ];
};

/**
 * Akcje tabeli – brak
 */
export const getTraderClientCardCartsTableActions = (
): IWiseTableAction[] => {
  return [];
};

/**
 * Parametry do pobierania danych (endpoint /sales-crm/clients/:clientId/carts)
 */
export const traderClientCardCartsTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/clients/:clientId/carts',
  params_list: null
};
